import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CryptomoedaService {

  constructor(private http: HttpClient) { }

  getCryptoTransactions(page: number, pageSize: number) : Observable<any>
  {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('page', page);
    queryParams = queryParams.append('pageSize', pageSize);

    return this.http.get(`${environment.apiUrl}/crypto/transaction`, {
      params: queryParams,
    });

  }

  addCryptoTransaction(transaction: any) : Observable<any>
  {
    return this.http.post(`${environment.apiUrl}/crypto/internal-transaction`, transaction);
  }

  getPriceBySymbol(symbol: string, symbolId: string, valor: number|null) : Observable<any>
  {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("symbol", symbol);
    queryParams = queryParams.append("symbolId", symbolId);

    if (valor !== null) {
      queryParams = queryParams.append("valor", valor.toString());
    }

    return this.http.get(`${environment.apiUrl}/symbol/price`,{params: queryParams});
  }

  canMakeCryptoTransactionWithoutHour() : Observable<boolean>
  {
    return this.http.get<boolean>(`${environment.apiUrl}/crypto/canMake`);
  }
}
